import {AntSelectOption} from "controls/react/ant/antSelect";
import {i18n} from "core/localization";

export enum LabelPosition {
	Middle = 'middle',
	Top = 'top',
	Bottom = 'bottom',
	Outside = 'outside',
	Inside = 'inside',
}


let labelPositionOptions: AntSelectOption[]
export function getLabelPositionOptions(){
	if(labelPositionOptions == null){
		labelPositionOptions = [{
			label: i18n('Inside'),
			value: LabelPosition.Inside
		},{
			label: i18n('Outside'),
			value: LabelPosition.Outside
		}, {
			label: i18n('Top'),
			value: LabelPosition.Top
		}, {
			label: i18n('Center'),
			value: LabelPosition.Middle
		},, {
			label: i18n('Bottom'),
			value: LabelPosition.Bottom
		}]
	}

	return labelPositionOptions
}

export enum LabelVisibility {
	Visible = 'visible',
	Hidden = 'hidden'
}

let labelVisibilityOptions: AntSelectOption[]
export function getLabelVisibilityOptions(){
	if(labelVisibilityOptions == null){
		labelVisibilityOptions = [{
			label: i18n('Visible'),
			value: LabelVisibility.Visible
		},{
			label: i18n('Hidden'),
			value: LabelVisibility.Hidden
		}]
	}

	return labelVisibilityOptions
}

export type LabelOptions = {
	visibility: LabelVisibility;
	color: string;
	size: number;
	position?: LabelPosition
}
